import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styled from 'styled-components';
import { ArrowDown } from '@components/Icons';
import SimpleButton, { COLOR, SIZE } from '@components/SimpleButton';
import messages from './messages';

const StyledButton = styled(SimpleButton)`
  > div {
    flex-direction: row-reverse;
  }
  span {
    margin: ${({ theme }) => theme.spacing(0, 2, 0, 2)};
  }
`;

const Container = styled.div`
  display: flex;
`;

const Separator = styled.div`
  border-right: 1px solid ${({ theme }) => theme.colors.platinum};
  margin: ${({ theme }) => theme.spacing(0, 6)};
  height: auto;
`;

const MenuButton = ({ onClick, className, intl: { formatMessage } }) => (
  <Container>
    <StyledButton
      className={className}
      label={formatMessage(messages.menu)}
      onClick={onClick}
      color={COLOR.SECONDARY}
      size={SIZE.SMALL}
      icon={<ArrowDown size="xsmall" />}
    />
    <Separator />
  </Container>
);

MenuButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(memo(MenuButton));
